export default __webpack_public_path__ + "static/media/slide16.3bc3159c.png";